<template>

<div id="galleries-container">

  <LoaderComponent v-if="!loaded" />
  <div v-else id="galleries">
    <div id="galleries-navigation">
      <div id="galleries-back">
        <button @click="$router.go(-1)"><font-awesome-icon :icon="['fas', 'reply']" /> Back</button>
      </div>
      <div id="galleries-list">
        <select v-model="selected" @change="goTo($event)">
          <option disabled value="">Select a Gallery</option>
          <option 
            v-for="gallery in allGalleries" 
            :key="gallery.galleryName"
            :value="gallery.links[2].href">
            {{ gallery.galleryName }}
          </option>
        </select>
      </div>
    </div>
    <div id="galleries-info">
      <div id="galleries-count">
        Number of MWNF Galleries: {{ pageInfo.total }}
      </div>
      <div v-if="!this.page" id="galleries-order">
        <button id="order-button" @click="reverse()">
          Click here to sort Galleries from 
          <span v-if="reversed">A - Z</span>
          <span v-else>Z - A</span>
        </button>
      </div>
      <div v-else id="all-galleries">
        <router-link id="all-galleries-button"
          :to="{ name: 'list'}">
          Show All Galleries
        </router-link>
      </div>
    </div>

    <div id="featured-galleries-container" v-if="ftGalleries && ftGalleries.length > 0 && $route.params.page == 1">
      <div id="featured-galleries-header">FEATURED GALLERIES</div>
      <div id="featured-galleries">
        <div class="featured-gallery" v-for="ftGallery in ftGalleries" :key="ftGallery.galleryId">
          <a :href="ftGallery.url">
            <div class="featured-gallery-image">
              <img :src="ftGallery.image" />
            </div>
            <div class="featured-gallery-name">{{ ftGallery.galleryName }}</div> 
          </a>
        </div>
      </div>
    </div>

    <!-- <div id="top-page-navigation" class="page-navigation-wrapper" v-if="displayPageNavigation">
      <PagesComponent :pageInfo="pageInfo" :navigatePage="navigatePage" :navigatePageDirect="navigatePageDirect"></PagesComponent>
    </div> -->

    <div id="galleries-grid">
      <div class="gallery" :class="`gallery-${index + 1}`" v-for="(gallery, index) in galleries" :key="gallery.galleryName">
        <a :href="gallery.links[2].href" class="gallery-link">
          <img :src="require(`../assets/homepages/${gallery.galleryKey}.png`)" />
          <span>{{ gallery.galleryName.toUpperCase() }}</span>
        </a>
      </div>
    </div>

    <div id="bottom-page-navigation" class="page-navigation-wrapper" v-if="displayPageNavigation">
      <PagesComponent :pageInfo="pageInfo" :navigatePage="navigatePage" :navigatePageDirect="navigatePageDirect"></PagesComponent>
    </div>

  </div>

</div>

</template>



<script>

import LoaderComponent from "./LoaderComponent.vue";
import PagesComponent from "./PagesComponent.vue";
import media from "../mixins/media.js";
import pageDisplay from "../mixins/pageDisplay.js";
import galleries from "../mixins/galleries.js";
export default { 
  name: "GalleriesPage",
  mixins: [media, pageDisplay, galleries],
  components: {
    "LoaderComponent": LoaderComponent,
    "PagesComponent": PagesComponent
  },
  data() {
    return {
      loaded: false,
      galleries: [],
      allGalleries: [],
      ftGalleries: [],
      reversed: false,
      selected: "",
      lessThan399: window.matchMedia("(max-width: 399px)").matches,
      page: this.$route.params.page,
      // Path, current/last page, total pages, etc.
      pageInfo: {},
      // Links to first/last/next/previous pages
      pages: {},
      resultsExist: false,
      displayPageNavigation: false,
    }
  },
  watch: {
    // Run loadGalleries again on page change
    "$route.params.page" () {
      if (this.$route.params.page == null) {
        this.loadGalleries("all");
      } else {
        this.loadGalleries("pages");
      }
    }
  },
  // computed: {
  //   noPartners: function() {
  //     console.log(this.galleries[0].galleryKey);
  //     for (let i = 0; i < this.galleries.length; i++) {
  //       if (this.galleries[i].galleryKey === "galleries") {
  //         this.galleries.splice(i, 1);
  //         break;
  //       }
  //     }
  //     console.log(this.galleries);
  //     return this.galleries;
  //   }
  // },
  methods: {
    goTo: function(e) {
      window.location.href = e.target.value;
    },
    reverse: function() {
      this.reversed = !this.reversed;
      this.galleries = this.galleries.reverse();
    },
    setResultsExist: function() {
      if (Object.entries(this.galleries).length === 0) {
        this.resultsExist = false;
      } else {
        this.resultsExist = true;
      }
    },
    // Navigate to appropriate page (first/last/next/previous)
    navigatePage: function(page) {
      let url;
      if (page === "first") {
        url = this.pages[0].href;
      } else if (page === "last") {
        url = this.pages[1].href;
      } else if (page === "next") {
        url = this.pages[2].href;
      } else if (page === "previous") {
        url = this.pages[3].href;
      }
      return axios({ method: "GET", "url": url }).then(result => {
        // No longer needed (?)
        // for (let i = 0; i < result.data.items.length; i++) {
        //   if (result.data.items[i].galleryKey === "galleries") {
        //     result.data.items.splice(i, 1);
        //     break;
        //   }
        // }
        this.galleries = result.data.items;
        this.pageInfo = result.data.page;
        this.pages = result.data.links;
        this.$router.push({ name: "list", params: { page: this.pageInfo.currentPage } });
      }, error => {
        console.error(error);
      });
    },
    // Navigate directly to a page by clicking a number
    navigatePageDirect: function(page) {
      this.$router.push({ name: "list", params: { page: page } });
    },
    getFeaturedGalleries: function () {
      return axios({ method: "GET", "url": `${process.env.VUE_APP_DXA_ENDPOINT}/thg/galleries?bf=1&hash=${process.env.VUE_APP_API_HASH}` }).then(result => {
        let array = [];
        for (let gallery in result.data.items) {
          array.push(result.data.items[gallery]);
        }
        console.log(array);
        this.ftGalleries = array;
      }, error => {
        console.error(error);
      });
    }
  },
  mounted() {
    if (this.$route.params.page) {
      this.loadGalleries("pages");
    } else {
      this.loadGalleries("all");
    }
    this.loadGalleries("list");
    this.getFeaturedGalleries();
  },
  beforeRouteUpdate(to, from, next) {
    to.meta.scrollPos = window.scrollY;
    return next();
  },
}

</script>



<style scoped lang="scss">


#galleries-container {
  @include flex-center;
  background-color: white;
  width: 100%;
}

#galleries {
  width: 100%;
  padding: 50px;
}

.loader-container {
  min-height: 200px;
}

#galleries-navigation {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
    #galleries-back .fas {
      font-size: 75%;
      padding-right: 4px;
    }
    #galleries-back button {
      @include button-styles;
      padding: 2px;
      font-weight: bold;
    }

#galleries-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
  #galleries-count,
  #all-galleries {
    font-weight: bold;
  }
    #all-galleries a {
      text-decoration: none;
      color: black;
    }
      #all-galleries a:hover {
        text-decoration: underline;
      }
  #order-button {
    @include button-styles;
    font-weight: bold;
  }

#featured-galleries-container {
  @include flex-center;
  flex-direction: column;
  background-color: $background-color;
  padding: 20px;
}
#featured-galleries-header {
  font-size: 150%;
  font-weight: bold;
  color: $theme-dark;
  text-align: center;
  margin-bottom: 20px;
}
#featured-galleries {
  @include flex-center;
  flex-wrap: wrap;
}
.featured-gallery {
  position: relative;
  margin: 10px;
}
  .featured-gallery-image {
    @include flex-center;
    height: 150px;
    width: 150px;
  }
    .featured-gallery-image img {
      @include image-scale;
      object-fit: contain;
    }
  .featured-gallery-name {
    @include flex-center;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 150%;
    font-weight: bold;
    color: white;
    text-shadow: 2px 2px 5px black;
    text-align: center;
    overflow-wrap: break-word;
    // word-break: break-all;
    padding: 5px;
  }

#galleries-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 35px;
  width: 100%;
  margin: 50px 0;
}
  .gallery {
    @include flex-center;
    width: 100%;
    box-shadow: 0px 1px 4px 1px rgba(black, 0.4);
  }
  .gallery-link {
    @include flex-center;
    flex-direction: column;
    width: 100%;
    color: $light-text;
    text-align: center;
    text-decoration: none;
  }
    .gallery-link img {
      @include image-scale;
    }
    .gallery-link span {
      @include flex-center;
      height: 50px;
      width: 100%;
      background-color: $theme-medium-dark;
      padding: 5px;
    }

/* IE-only */
@media only screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #galleries-container {
    overflow: hidden;
  }
  #galleries-grid {
    display: -ms-grid;
    -ms-grid-columns: 1fr 35px 1fr 35px 1fr 35px 1fr;
  }
    .gallery-1,
    .gallery-5,
    .gallery-9,
    .gallery-13,
    .gallery-17,
    .gallery-21,
    .gallery-25,
    .gallery-29 {
      -ms-grid-column: 1;
    }
    .gallery-2,
    .gallery-6,
    .gallery-10,
    .gallery-14,
    .gallery-18,
    .gallery-22,
    .gallery-26,
    .gallery-30,
    .gallery-34 {
      -ms-grid-column: 3;
    }
    .gallery-3,
    .gallery-7,
    .gallery-11,
    .gallery-15,
    .gallery-19,
    .gallery-23,
    .gallery-27,
    .gallery-31,
    .gallery-35 {
      -ms-grid-column: 5;
    }
    .gallery-4,
    .gallery-8,
    .gallery-12,
    .gallery-16,
    .gallery-20,
    .gallery-24,
    .gallery-28,
    .gallery-32 {
      -ms-grid-column: 7;
    }
    .gallery-1,
    .gallery-2,
    .gallery-3,
    .gallery-4 {
      -ms-grid-row: 1;
    }
    .gallery-5,
    .gallery-6,
    .gallery-7,
    .gallery-8 {
      -ms-grid-row: 2;
    }
    .gallery-9,
    .gallery-10,
    .gallery-11,
    .gallery-12 {
      -ms-grid-row: 3;
    }
    .gallery-13,
    .gallery-14,
    .gallery-15,
    .gallery-16 {
      -ms-grid-row: 4;
    }
    .gallery-17,
    .gallery-18,
    .gallery-19,
    .gallery-20 {
      -ms-grid-row: 5;
    }
    .gallery-21,
    .gallery-22,
    .gallery-23,
    .gallery-24 {
      -ms-grid-row: 6;
    }
    .gallery-25,
    .gallery-26,
    .gallery-27,
    .gallery-28 {
      -ms-grid-row: 7;
    }
    .gallery-29,
    .gallery-30,
    .gallery-31,
    .gallery-32 {
      -ms-grid-row: 8;
    }
    .gallery-33,
    .gallery-34,
    .gallery-35,
    .gallery-36 {
      -ms-grid-row: 9;
    }
    .gallery {
      width: 100%;
      margin-bottom: 35px;
    }
    .gallery a {
      position: relative;
      height: 100%;
      width: 100%;
    }
}

@media only screen and (max-width: 1199px) {
  #galleries-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
/* IE-only */
@media only screen and (max-width: 1199px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #galleries-grid {
    display: -ms-grid;
    -ms-grid-columns: 1fr 35px 1fr 35px 1fr;
  }
    .gallery-1,
    .gallery-4,
    .gallery-7,
    .gallery-10,
    .gallery-13,
    .gallery-16,
    .gallery-19,
    .gallery-22,
    .gallery-25,
    .gallery-28,
    .gallery-31,
    .gallery-34 {
      -ms-grid-column: 1;
    }
    .gallery-2,
    .gallery-5,
    .gallery-8,
    .gallery-11,
    .gallery-14,
    .gallery-17,
    .gallery-20,
    .gallery-23,
    .gallery-26,
    .gallery-29,
    .gallery-32,
    .gallery-35 {
      -ms-grid-column: 3;
    }
    .gallery-3,
    .gallery-6,
    .gallery-9,
    .gallery-12,
    .gallery-15,
    .gallery-18,
    .gallery-21,
    .gallery-24,
    .gallery-27,
    .gallery-30,
    .gallery-33,
    .gallery-36 {
      -ms-grid-column: 5;
    }
    .gallery-1,
    .gallery-2,
    .gallery-3 {
      -ms-grid-row: 1;
    }
    .gallery-4,
    .gallery-5,
    .gallery-6 {
      -ms-grid-row: 2;
    }
    .gallery-7,
    .gallery-8,
    .gallery-9 {
      -ms-grid-row: 3;
    }
    .gallery-10,
    .gallery-11,
    .gallery-12 {
      -ms-grid-row: 4;
    }
    .gallery-13,
    .gallery-14,
    .gallery-15 {
      -ms-grid-row: 5;
    }
    .gallery-16,
    .gallery-17,
    .gallery-18 {
      -ms-grid-row: 6;
    }
    .gallery-19,
    .gallery-20,
    .gallery-21 {
      -ms-grid-row: 7;
    }
    .gallery-22,
    .gallery-23,
    .gallery-24 {
      -ms-grid-row: 8;
    }
    .gallery-25,
    .gallery-26,
    .gallery-27 {
      -ms-grid-row: 9;
    }
    .gallery-28,
    .gallery-29,
    .gallery-30 {
      -ms-grid-row: 10;
    }
    .gallery-31,
    .gallery-32,
    .gallery-33 {
      -ms-grid-row: 11;
    }
    .gallery-34,
    .gallery-35,
    .gallery-36 {
      -ms-grid-row: 12;
    }
}

@media only screen and (max-width: 849px) {
  #galleries-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
/* IE-only */
@media only screen and (max-width: 849px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #galleries-grid {
    display: -ms-grid;
    -ms-grid-columns: 1fr 35px 1fr;
  }
    .gallery-1,
    .gallery-3,
    .gallery-5,
    .gallery-7,
    .gallery-9,
    .gallery-11,
    .gallery-13,
    .gallery-15,
    .gallery-17,
    .gallery-19,
    .gallery-21,
    .gallery-23,
    .gallery-25,
    .gallery-27,
    .gallery-29,
    .gallery-31,
    .gallery-33,
    .gallery-35 {
      -ms-grid-column: 1;
    }
    .gallery-2,
    .gallery-4,
    .gallery-6,
    .gallery-8,
    .gallery-10,
    .gallery-12,
    .gallery-14,
    .gallery-16,
    .gallery-18,
    .gallery-20,
    .gallery-22,
    .gallery-24,
    .gallery-26,
    .gallery-28,
    .gallery-30,
    .gallery-32,
    .gallery-34,
    .gallery-36 {
      -ms-grid-column: 3;
    }
    .gallery-1,
    .gallery-2 {
      -ms-grid-row: 1;
    }
    .gallery-3,
    .gallery-4 {
      -ms-grid-row: 2;
    }
    .gallery-5,
    .gallery-6 {
      -ms-grid-row: 3;
    }
    .gallery-7,
    .gallery-8 {
      -ms-grid-row: 4;
    }
    .gallery-9,
    .gallery-10 {
      -ms-grid-row: 5;
    }
    .gallery-11,
    .gallery-12 {
      -ms-grid-row: 6;
    }
    .gallery-13,
    .gallery-14 {
      -ms-grid-row: 7;
    }
    .gallery-15,
    .gallery-16 {
      -ms-grid-row: 8;
    }
    .gallery-17,
    .gallery-18 {
      -ms-grid-row: 9;
    }
    .gallery-19,
    .gallery-20 {
      -ms-grid-row: 10;
    }
    .gallery-21,
    .gallery-22 {
      -ms-grid-row: 11;
    }
    .gallery-23,
    .gallery-24 {
      -ms-grid-row: 12;
    }
    .gallery-25,
    .gallery-26 {
      -ms-grid-row: 13;
    }
    .gallery-27,
    .gallery-28 {
      -ms-grid-row: 14;
    }
    .gallery-29,
    .gallery-30 {
      -ms-grid-row: 15;
    }
    .gallery-31,
    .gallery-32 {
      -ms-grid-row: 16;
    }
    .gallery-33,
    .gallery-34 {
      -ms-grid-row: 17;
    }
    .gallery-35,
    .gallery-36 {
      -ms-grid-row: 18;
    }
}

@media only screen and (max-width: 599px) {
  #galleries {
    padding: 30px;
  }
  #galleries-info {
    flex-direction: column;
    align-items: flex-start;
  }
    #galleries-order {
      margin-top: 8px;
    }
}

@media only screen and (max-width: 499px) {
  #galleries-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
/* IE-only */
@media only screen and (max-width: 499px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #galleries-grid {
    display: -ms-grid;
    -ms-grid-columns: 1fr;
  }
    .gallery-1, .gallery-2,
    .gallery-3, .gallery-4,
    .gallery-5, .gallery-6,
    .gallery-7, .gallery-8,
    .gallery-9, .gallery-10,
    .gallery-11, .gallery-12,
    .gallery-13, .gallery-14,
    .gallery-15, .gallery-16,
    .gallery-17, .gallery-18,
    .gallery-19, .gallery-20,
    .gallery-21, .gallery-22,
    .gallery-23, .gallery-24,
    .gallery-25, .gallery-26,
    .gallery-27, .gallery-28,
    .gallery-29, .gallery-30,
    .gallery-31, .gallery-32,
    .gallery-33, .gallery-34,
    .gallery-35, .gallery-36 {
      -ms-grid-column: 1;
    }
}

@media only screen and (max-width: 374px) {
  #galleries-navigation {
    flex-direction: column;
  }
  #galleries-back {
    margin-bottom: 20px;
  }
  #galleries-list select {
    width: 100%;
  }
}

</style>